import { render, staticRenderFns } from "./VerticalKeyMetrics.vue?vue&type=template&id=97187b80"
import script from "./VerticalKeyMetrics.vue?vue&type=script&lang=js"
export * from "./VerticalKeyMetrics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports